import { useState } from "react";
import { Search, Trash2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, eur, errMsg } from "@/lib/api";

const List = ({ title, rows, testid }) => (
  <div data-testid={testid} className="border border-[#3B4157] bg-[#292D3C] p-4">
    <div className="font-display font-bold uppercase tracking-widest text-sm">{title} · {rows.length}</div>
    <ul className="mt-3 space-y-1 text-sm text-slate-400">
      {rows.map((r) => <li key={r.id} className="font-mono-x">{r.number} · {r.created_at?.slice(0, 10)} · {r.status}{r.total != null && ` · ${eur(r.total)}`}</li>)}
      {!rows.length && <li className="text-slate-600">—</li>}
    </ul>
  </div>
);

export default function AdminPrivacy() {
  const [email, setEmail] = useState("");
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);

  const lookup = async (e) => {
    e.preventDefault();
    try { setRes((await api.get("/admin/privacy/lookup", { params: { email } })).data); } catch (e2) { toast.error(errMsg(e2)); }
  };

  const erase = async () => {
    if (!window.confirm(`Ištrinti visus kliento ${email} asmens duomenis? Veiksmo atšaukti negalima.`)) return;
    setBusy(true);
    try {
      const { data } = await api.post("/admin/privacy/erase", { email });
      toast.success(`Ištrinta užklausų: ${data.inquiries_deleted}, nuasmeninta užsakymų: ${data.orders_anonymized}`);
      setRes(null); setEmail("");
    } catch (e2) { toast.error(errMsg(e2)); } finally { setBusy(false); }
  };

  const found = res && (res.orders.length || res.inquiries.length);
  return (
    <div data-testid="admin-privacy" className="space-y-6 max-w-3xl">
      <h1 className="font-display font-black uppercase text-4xl tracking-tight">Duomenų apsauga</h1>
      <p className="text-sm text-slate-400">Kliento prašymu (teisė būti pamirštam) ištrinkite jo asmens duomenis pagal el. paštą. Užklausos ištrinamos visiškai, o užsakymuose asmens duomenys pakeičiami į „[ištrinta]“ – sumos ir prekės lieka apskaitai.</p>
      <form onSubmit={lookup} className="flex gap-2">
        <input data-testid="privacy-email-input" type="email" required value={email} onChange={(e) => { setEmail(e.target.value); setRes(null); }} placeholder="kliento@pastas.lt"
          className="flex-1 h-11 px-3 bg-[#292D3C] border border-[#3B4157] text-sm outline-none focus:border-orange-500" />
        <button data-testid="privacy-lookup-btn" className="h-11 px-5 inline-flex items-center gap-2 border border-[#3B4157] hover:border-orange-500 font-display font-bold uppercase tracking-widest text-sm"><Search className="w-4 h-4" />Ieškoti</button>
      </form>
      {res && (
        <div className="space-y-4" data-testid="privacy-results">
          <div className="grid sm:grid-cols-2 gap-4">
            <List title="Užsakymai" rows={res.orders} testid="privacy-orders" />
            <List title="Užklausos" rows={res.inquiries} testid="privacy-inquiries" />
          </div>
          {found ? (
            <button data-testid="privacy-erase-btn" onClick={erase} disabled={busy} className="h-11 px-5 inline-flex items-center gap-2 bg-red-500 text-white font-display font-bold uppercase tracking-widest text-sm hover:bg-red-400 disabled:opacity-60">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Trash2 className="w-4 h-4" />}Ištrinti kliento duomenis
            </button>
          ) : <p data-testid="privacy-not-found" className="text-sm text-slate-500">Duomenų su šiuo el. paštu nerasta.</p>}
        </div>
      )}
    </div>
  );
}
